<template>
  <v-container>
    <v-layout row>
      <v-flex xs6>
        <v-text-field
          v-model="userFilter"
          clearable
          label="Search"
          @change="getUsers">
        </v-text-field>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-simple-table
          fixed-header
          class="mb-5">
          <thead>
            <tr>
              <th class="text-left user-table__header">Account</th>
              <th class="text-left user-table__header">Username</th>
              <th class="text-left user-table__header">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr class="no-users-found" v-if="filteredUsers.length == 0">
              <td colspan=3>
                <span>Please refine your search.</span>
              </td>
            </tr>
            <tr v-for="user in filteredUsers" :key="user.userId">
              <td>{{ user.accountId }}</td>
              <td>
                <span @click="selectUser(user)" class="clickable">{{ user.username }}</span></td>
              <td>{{ user.email }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-dialog
          max-width="750"
          persistent
          v-model="userDialog">
          <v-card class="pa-5">
            <detail
              v-if="selectedUser"
              :user="selectedUser"
              :clients="clients"
              @clientsUpdated="updateClients"
              @newClient="newClient">
            </detail>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="cancelDialog">
                Cancel
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="saveUser">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <change-password
          :showDialog="changePasswordDialog"
          @cancelChangePassword="cancelChangePassword">
        </change-password>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Detail from '../components/Users/Detail'
import ChangePassword from '../components/Users/ChangePassword'

export default {
  components: {
    Detail,
    ChangePassword
  },
  data () {
    return {
      users: [],
      clients: [],
      selectedUser: null,
      userDialog: false,
      changePasswordDialog: false,
      userFilter: null
    }
  },
  methods: {
    getUsers () {
      const baseURI = '/user/get?searchTerm='
      this.$http.get(baseURI + encodeURIComponent(this.userFilter))
      .then((result) => {
        this.users = result.data.users
      })
    },
    getClients () {
      const baseURI = '/client/get'
      this.$http.get(baseURI)
      .then((result) => {
        this.clients = result.data.clients
      })
    },
    updateClients (e) {
      let i = e.index
      let client = this.selectedUser.clients[i]
      let newClient = this.clients.filter(c => {
        return c.clientId === e.value
      })[0]

      client.clientId = e.value
      client.clientCode = newClient.clientCode
      client.clientName = newClient.clientName
    },
    selectUser (e) {
      this.selectedUser = e
      this.userDialog = true
    },
    newUser () {
      this.selectedUser = {
        clients: []
      }
      this.userDialog = true
    },
    newClient () {
      this.selectedUser.clients.push({
        databaseId: 0
      })
    },
    cancelDialog () {
      this.getUsers()
      this.userDialog = false
    },
    cancelChangePassword () {
      this.changePasswordDialog = false
    },
    saveUser () {
      const baseURI = '/user/UpdateManagedUser'
      this.$http.post(baseURI, this.selectedUser)
      .then((result) => {
        if (result) {
          this.getUsers()
          this.userDialog = false
        }
      })
    }
  },
  computed: {
    filteredUsers () {
      return this.users
    }
  },
  created () {
    this.getClients()
  }
}
</script>

<style scoped>
.user-table__header {
  background: #e8e8e8!important;
}

.no-users-found {
  text-align: center;
  color: red;
}

.clickable {
  color: #03739c;
  cursor: pointer;
}

.client-list {
  background-color: transparent;
}
</style>
